import clsx from "clsx";
import { useId } from "react";

type AuthHoneypotFieldProps = {
    value: string;
    onChange: (value: string) => void;
};

/**
 * Hidden field for naive bot deterrence. Must stay empty for real users.
 * aria-hidden keeps it out of the accessibility tree; not tabbable.
 */
export function AuthHoneypotField({
    value,
    onChange,
}: AuthHoneypotFieldProps) {
    const fallbackName = `field-${useId()}`;

    return (
        <div
            aria-hidden="true"
            className={clsx(
                "pointer-events-none absolute left-0 top-0 -z-10",
                "h-px w-px overflow-hidden opacity-0",
                "[clip:rect(0,0,0,0)] [clip-path:inset(50%)]"
            )}
        >
            <input
                type="text"
                name={fallbackName}
                tabIndex={-1}
                autoComplete="off"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                data-1p-ignore
                data-lpignore="true"
            />
        </div>
    );
}
